<div class="blog-card-container">
  <div class="blog-card">
    <button class="favorite-button" [class.favorited]="blog?.isFavorite"
      (click)="toggleFavorite(blog)"
      [matTooltip]="!blog?.isFavorite ? ('event.add_to_favorite' | translate) : ('event.remove_from_favorite' | translate)">
      ★
    </button>
    @if (blog?.blog.image) {
      <img src="{{blog?.blog?.image}}" class="blog-image">
    }
    @if (videoUrl && !blog?.blog.image) {
      <div>
        <iframe [src]="videoUrl" class="video">
        </iframe>
      </div>
    }
    <div class="blog-content">
      <h3 class="blog-title">{{blog?.blog?.header}}</h3>
      @if (blog?.blog?.fullTitle) {
        <div class="blog-full-title" >
          {{blog?.blog?.fullTitle}}
        </div>
      }
      @if (blog?.blog.fullText) {
        <p class="blog-description" [innerHTML]="blog?.blog.fullText"></p>
      }
      @if (blog?.blog.link) {
        <div class="blog-link">
          <a href="{{blog?.blog.link | linkHttp}}" target="_blank">{{blog?.blog.linkLabel}}</a>
        </div>
      }
      <div class="blog-organization">
        <img class="org-logo" [src]="getImage(blog?.blog?.user?.logo)" >
        <span class="org-name">{{blog?.blog?.user?.firstName}} {{blog?.blog?.user?.lastName}}</span>
      </div>
    </div>
    <div class="blog-recommendation">
      <div class="recommender">
        @if (!blog?.user?.logo) {
          <img class="recommender-avatar" src="assets/images/avatars/profile.jpg">
        }
        @if (blog?.user?.logo) {
          <img class="recommender-avatar" [src]="getImage(blog?.user.logo)">
        }
        <div class="recommender-name">{{blog?.user?.firstName}} {{blog?.user?.lastName}}</div>
      </div>
      <div class="recommendation-text">{{blog?.recommendation_text}}</div>
    </div>
    <div class="navigation">
      <button mat-raised-button class="mat-accent" (click)="subscriptionToBlog(blog?.blog?.id, index)">{{'blog.subscribe_to_blog' | translate}}</button>
    </div>
  </div>
</div>

